import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Alert, Card, Row, Col, Button, Modal } from 'react-bootstrap';
import { Page, Terminal } from 'components';
import Header from '../../../../components/Header/Header';
import { getToken } from 'actions';

const wsUrl = process.env.REACT_APP_API_MONITORA.replace('https', 'wss').replace('http', 'ws');
const refreshRate = 15000
const resetPasswordCommand = process.env.REACT_APP_SUPPORT_RESET_PASSWORD_CMD;

let socket;
let publicKey;

const ConectedNir = (props) => {
  const history = useHistory();
  const requestRef = useRef(null);
  const imageRef = useRef(null);
  const prevImageUrlRef = useRef(null);
  const serialNumber = useParams().id;

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.supportnir?.read !== true) {
    window.location.replace('/home');
  }

  const [imageSrc, setImageSrc] = useState('');
  const [hideImage, setHideImage] = useState(false);
  const [streamInternalCam, setStreamInternalCam] = useState(false);
  const [imageCamSrc, setImageCamSrc] = useState('');
  const [connectionStabished, setConnectionStabished] = useState(false)
  const [inputValueAlert, setInputValueAlert] = useState('');
  const [response, setResponse] = useState('Console\n');
  const [equipConfig, setEquipConfig] = useState({
    'serial': '--',
    'webcam': false,
    'freq_v': '--',
    'serv_e': '--',
    'serv_m': '--',
    'serv_d': '--',
    'calib_id': '--',
    'calib': '--',
    'eixo_x': '--',
    'eixo_y': '--',
    'eixo_z': '--',
    'v_firmware': '--',
    'v_firmware_osc': '--',
    'activation_date': '--',
    'activation_days': '--',
    'volume_corr_densidade': '--',
    'densidade_esfera': '--',
    'offset_bal1': '--',
    'offset_bal2': '--',
    'cross_check': '--',
    'sw': '--',
    'sws': '--'
  })

  // Estado para confirmação de ações críticas
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null); // 'calibrar' | 'reset_senha' | 'chart'
  const openConfirm = (action) => { setConfirmAction(action); setShowConfirmModal(true); };
  const closeConfirm = () => { setShowConfirmModal(false); setConfirmAction(null); };

  const handleSubmit = (inputValue) => {
    if (!connectionStabished) return;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: inputValue
        }
      }
    };
    socket.send(JSON.stringify(command));
  };

  const handleSubmitAlert = (event) => {
    if (!inputValueAlert || !connectionStabished) return;

    event.preventDefault();
    const command = {
      type: 'alert',
      room: serialNumber,
      msg: inputValueAlert
    };
    socket.send(JSON.stringify(command));

    setInputValueAlert('');
  };

  const base64ToBlob = (base64, mime = 'image/png') => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  };

  const handleNewFrame = (imgData) => {
    requestRef.current = requestAnimationFrame(() => {
      try {
        const blob = base64ToBlob(imgData, 'image/png');
        if (prevImageUrlRef.current) {
          URL.revokeObjectURL(prevImageUrlRef.current);
        }
        const objectUrl = URL.createObjectURL(blob);
        prevImageUrlRef.current = objectUrl;
        setImageSrc(objectUrl);
      } catch (err) {
        setImageSrc(`data:image/png;base64,${imgData}`);
      }
    });
  };

  const handleImageLoad = (e) => {
    const img = e.target;
    if (!img) return;
    const rect = img.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      // update ratios if other logic depends on them
      // ...existing code...
    }
  };

  const handleConnect = () => {
    let pingInterval
    // Criar uma nova instância WebSocket
    socket = new WebSocket(wsUrl);

    pingInterval = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, 20000);

    socket.onopen = () => {
      setConnectionStabished(true)
    };

    socket.onmessage = (event) => {
      const data = event.data;
      let json_msg = JSON.parse(data);

      if (json_msg.type === "invalid_user") {
        if (json_msg?.msg) {
          alert(json_msg?.msg)
        } else {
          alert("Sem permissão!");
        }
        handleDisconnect();
      }

      if (json_msg.type === "valid_user") {
        setConnectionStabished(true)
        handleLoadData()
      }

      if (json_msg.type === "desconnect") {
        setConnectionStabished(false)
      }

      if (json_msg.type === "connected") {
        setConnectionStabished(true)
        handleLoadData()
      }

      if (json_msg.pubkey) {
        publicKey = json_msg.pubkey;

        socket.send(
          JSON.stringify({
            type: 'join',
            room: serialNumber,
            user_id: user?._id,
            name: user?.name,
            email: user?.email,
            client: 'client',
            page: 'supportnir',
            token: getToken(),
            content: {
              name: `${user.email}-API-SUPORTE`
            },
          }));

      } else {
        if (json_msg?.content?.img) {
          handleNewFrame(json_msg.content.img);
          return;
        }

        if (json_msg?.content?.text) {
          requestAnimationFrame(() => {
            setResponse(json_msg.content.text);
          });
          return;
        }

        if (json_msg?.content?.img_cam) {
          requestAnimationFrame(() => {
            setImageCamSrc(`data:image/png;base64,${json_msg.content.img_cam}`);
          });
          return;
        }

        if (json_msg?.content?.network_config) {
          // setNetworkConfig(json_msg.content.network_config);
          return;
        }

        if (json_msg?.content?.equip_config) {
          requestAnimationFrame(() => {
            setEquipConfig(json_msg.content.equip_config);
          });
          return;
        }
      }
    };

    socket.onclose = () => {
      clearInterval(pingInterval)
    };
  };

  const handleLoadData = () => {
    socket.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'load_data',
          parameters: {}
        },
      })
    );

    socket.send(
      JSON.stringify({
        type: 'connect_support',
        room: serialNumber,
        hidden: user.master ? user.master : false
      })
    );
  }

  const handleImageClick = (event) => {
    if (!connectionStabished) return;

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    socket.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'click',
          parameters: {
            x: x,
            y: y
          }
        }
      })
    );
  };

  const sendGetScreen = () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'connect_support',
          room: serialNumber,
          stream_internal_cam: streamInternalCam,
          hidden: user.master ? user.master : false
        })
      );
    }
  };

  useEffect(() => {
    const interval1 = setInterval(() => {
      sendGetScreen();
    }, refreshRate);
    return () => {
      clearInterval(interval1);
    };
  }, [socket, streamInternalCam]);

  // Função para desconectar o WebSocket
  const handleDisconnect = () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'desconnect_support',
          room: serialNumber
        })
      );
      socket.close();
      setConnectionStabished(false);
    }
    history.push('/supportnir');
  };

  useEffect(() => {
    handleConnect();
    return () => {
      if (socket) socket.close();
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
      if (prevImageUrlRef.current) {
        URL.revokeObjectURL(prevImageUrlRef.current);
      }
    };
  }, []);

  const handleChart = () => {
    if (!connectionStabished) return;

    // É mais seguro e legível montar o comando Python separado.
    const pythonScriptCommand = `from db import getInstance as DB; db = DB(); db.clear_charts('CUSTOM'); db.clear_charts('COMPLEMENT')`;
    const fullShellCommand = `/home/orangepi/venv/bin/python -c "${pythonScriptCommand}"`;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: fullShellCommand
        }
      }
    };
    socket.send(JSON.stringify(command));
  }

  const handleCalibrar = () => {
    if (!connectionStabished) return;

    // Função auxiliar para gerar SHA-256 (hex) usando Web Crypto API
    const sha256Hex = async (text) => {
      try {
        const encoder = new TextEncoder();
        const data = encoder.encode(text);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
        return Array.from(new Uint8Array(hashBuffer))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('');
      } catch (err) {
        console.error('Falha ao gerar SHA-256', err);
        return null;
      }
    };

    (async () => {
      const raw = `${serialNumber}Mtc`;
      const hash = await sha256Hex(raw);
      if (!hash) {
        alert('Não foi possível gerar hash para calibração.');
        return;
      }
      // Monta comando curl conforme solicitado
      const fullShellCommand = `curl -X GET http://localhost:3000/api/v1/atualizacalibracao/${hash}`;

      const command = {
        type: 'message',
        room: serialNumber,
        content: {
          command: 'process',
          parameters: {
            command: fullShellCommand
          }
        }
      };
      socket.send(JSON.stringify(command));
    })();
  }

  const handleResetSenha = () => {
    if (!connectionStabished) return;

    const fullShellCommand = resetPasswordCommand;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: fullShellCommand
        }
      }
    };
    socket.send(JSON.stringify(command));
  }

  return (
    <Page className="p-3" title="Suporte Nir">
      <Header page={"Suporte Nir"} handleDisconnect={handleDisconnect} />

      <Card className='mb-2 mt-2 p-2'>
        <Row className='g-2'>
          <Col>
            {connectionStabished ?
              <Alert
                className='ms-1 me-1 mt-2 mb-2 p-2'
                style={{
                  backgroundColor: 'var(--success-color, #198754)',
                  color: '#fff',
                  border: 'none'
                }}
              >
                <p style={{ marginBottom: 0 }}>
                  Conectado
                </p>
              </Alert>
              :
              <Alert
                className='ms-1 me-1 mt-2 mb-2 p-2'
                style={{
                  backgroundColor: 'var(--danger-color, #dc3545)',
                  color: '#fff',
                  border: 'none'
                }}
              >
                <p style={{ marginBottom: 0 }}>
                  Desconectado
                </p>
              </Alert>
            }
          </Col>
          <Col className='d-flex justify-content-end align-items-center'>
            <Button
              size="sm"
              className='ms-1 me-1 mt-1'
              onClick={() => { setHideImage(!hideImage) }}
              variant={hideImage ? "success" : "secondary"}
            >
              {hideImage ? 'Mostrar Imagem' : 'Ocultar Imagem'}
            </Button>
            <Button
              size="sm"
              className='ms-1 me-1 mt-1'
              onClick={() => { handleDisconnect() }}
              style={{
                backgroundColor: 'var(--danger-color, #dc3545)',
                color: '#fff',
                border: 'none'
              }}
            >
              Desconectar
            </Button>
          </Col>
        </Row>
      </Card>

      <Card className='mb-2 p-2'>
        <Row className='g-2'>
          {!hideImage && (
            <Col>
              <div>
                {!imageSrc ? (
                  <span style={{ color: 'black' }}>
                    Aguardando imagem...
                  </span>
                ) : (
                  <img
                    onClick={handleImageClick}
                    src={imageSrc}
                    style={{
                      minWidth: 800,
                      minHeight: 480,
                      maxWidth: 1280,
                      maxHeight: 720,
                      objectFit: 'cover',
                      cursor: connectionStabished ? 'pointer' : 'none',
                      opacity: connectionStabished ? 1 : 0.7,
                      filter: connectionStabished ? 'none' : 'grayscale(100%)',
                      borderRadius: '5px', // Arredondar a borda da imagem
                      border: '3px solid grey', // Contorno sutil da imagem
                    }}
                  />
                )}
              </div>
            </Col>
          )}

          <Col>
            <div className="p2" style={{ height: 720, minWidth: 500, maxWidth: hideImage ? 'none' : 1280, overflowY: 'auto' }}>
              <Terminal
                onCommandSubmit={handleSubmit}
                response={response}
                connectionStabished={connectionStabished}
                permission={user?.permission?.supportnir?.write}
                allowAllCommands={true}
              />
            </div>
          </Col>
        </Row>
      </Card>

      <Modal
        show={showConfirmModal}
        onHide={closeConfirm}
        centered
        backdrop="static"
        contentClassName={document.body.classList.contains('dark-theme') ? 'bg-dark text-light border-secondary' : 'bg-white'}
      >
        <Modal.Header
          closeButton
          className={document.body.classList.contains('dark-theme') ? 'bg-dark text-light border-secondary' : undefined}
          style={{ borderBottom: '1px solid', borderColor: document.body.classList.contains('dark-theme') ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }}
        >
          <Modal.Title className="fw-semibold" style={{ fontSize: '1rem' }}>Confirmação</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={document.body.classList.contains('dark-theme') ? 'bg-dark text-light' : undefined}
          style={{ background: document.body.classList.contains('dark-theme') ? '#1f2428' : '#fff' }}
        >
          {confirmAction === 'calibrar' && (
            <p className="mb-0">Tem certeza que deseja executar a calibração? Esta ação enviará um comando remoto ao equipamento.</p>
          )}
          {confirmAction === 'reset_senha' && (
            <p className="mb-0">Tem certeza que deseja resetar a senha? Esta ação irá limpar/definir uma senha vazia no equipamento.</p>
          )}
          {confirmAction === 'chart' && (
            <p className="mb-0">Confirmar atualização forçada das curvas? Isso pode limpar ou regenerar dados de gráfico.</p>
          )}
        </Modal.Body>
        <Modal.Footer
          className={document.body.classList.contains('dark-theme') ? 'bg-dark text-light border-secondary' : undefined}
          style={{ borderTop: '1px solid', borderColor: document.body.classList.contains('dark-theme') ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }}
        >
          <Button
            onClick={closeConfirm}
            style={{
              backgroundColor: 'transparent',
              color: document.body.classList.contains('dark-theme') ? '#fff' : '#6c757d',
              border: '1px solid',
              borderColor: document.body.classList.contains('dark-theme') ? '#fff' : '#6c757d'
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              if (confirmAction === 'calibrar') {
                closeConfirm();
                handleCalibrar();
              } else if (confirmAction === 'reset_senha') {
                closeConfirm();
                handleResetSenha();
              } else if (confirmAction === 'chart') {
                closeConfirm();
                handleChart();
              } else {
                closeConfirm();
              }
            }}
            style={{
              backgroundColor: 'var(--brand-light-green, #8fad15)',
              color: '#fff',
              border: 'none'
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Page>
  );
};

export default ConectedNir;
